/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Pit2_TInputs */

const en_formatter_pit2_t = /** @type {(inputs: Formatter_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting cannot fix JSON with comments or trailing commas`)
};

const ko_formatter_pit2_t = /** @type {(inputs: Formatter_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포매팅으로 주석이나 뒤쪽 쉼표가 있는 JSON을 고칠 수는 없습니다`)
};

const ja_formatter_pit2_t = /** @type {(inputs: Formatter_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整形でコメントや末尾カンマのある JSON は直せません`)
};

/**
* | output |
* | --- |
* | "Formatting cannot fix JSON with comments or trailing commas" |
*
* @param {Formatter_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_pit2_t = /** @type {((inputs?: Formatter_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_pit2_t(inputs)
	if (locale === "ko") return ko_formatter_pit2_t(inputs)
	return ja_formatter_pit2_t(inputs)
});